import React from 'react';
export function TermsOfService() {
  return <section className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-460">
      <div className="max-w-3xl mx-auto" data-id="element-461">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-462">
          Terms of Service
        </h1>
        <p className="text-white/40 text-sm mb-12" data-id="element-463">
          Last updated: January 2025
        </p>

        <div className="space-y-8 text-white/80 leading-relaxed" data-id="element-464">
          <div data-id="element-465">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-466">1. Overview</h2>
            <p data-id="element-467">
              These Terms of Service ("Terms") govern your use of the website
              building services provided by aiwebsitepackage.com ("we", "our",
              "us"). By purchasing any of our packages or using our services,
              you agree to these Terms.
            </p>
          </div>

          <div data-id="element-468">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-469">2. Services</h2>
            <p data-id="element-470">
              We provide done-for-you website design and development services
              using the Magic Patterns platform. Our packages include website
              design, development, hosting, and AI-assisted editing capabilities
              as described on our pricing page. The specific deliverables depend
              on the package you purchase.
            </p>
          </div>

          <div data-id="element-471">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-472">3. Payment</h2>
            <ul className="list-disc list-inside space-y-2 text-white/70 ml-4" data-id="element-473">
              <li data-id="element-474">
                All prices are listed in Euros (€) and are one-time payments
                unless otherwise stated.
              </li>
              <li data-id="element-475">Payment is required before work begins on your website.</li>
              <li data-id="element-476">
                Payment can be made via bank transfer, PayPal, or other
                agreed-upon methods.
              </li>
              <li data-id="element-477">
                Prices are subject to change but any agreed-upon price will be
                honoured for your project.
              </li>
            </ul>
          </div>

          <div data-id="element-478">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-479">4. Delivery</h2>
            <ul className="list-disc list-inside space-y-2 text-white/70 ml-4" data-id="element-480">
              <li data-id="element-481">
                Websites are typically delivered within 48 hours after we
                receive all required content (text, images, logo) from you.
              </li>
              <li data-id="element-482">
                Delivery timelines depend on the timely provision of content and
                feedback from you.
              </li>
              <li data-id="element-483">
                We are not responsible for delays caused by late or incomplete
                content submissions.
              </li>
            </ul>
          </div>

          <div data-id="element-484">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-485">5. Revisions</h2>
            <p data-id="element-486">
              Each package includes a specified number of revision rounds as
              listed on the pricing page. Revisions cover changes to layout,
              text, images, and colours within the original scope. Requests for
              entirely new pages, features, or functionality beyond the original
              scope may incur additional charges, which will be discussed and
              agreed upon before work begins.
            </p>
          </div>

          <div data-id="element-487">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-488">
              6. Hosting & Domain
            </h2>
            <ul className="list-disc list-inside space-y-2 text-white/70 ml-4" data-id="element-489">
              <li data-id="element-490">
                Hosting is included for the duration specified in your package.
              </li>
              <li data-id="element-491">
                Domain registration is the client's responsibility and is
                purchased separately. We can assist with domain purchase and
                setup for an additional fee.
              </li>
              <li data-id="element-492">
                After the included hosting period expires, you may renew hosting
                directly or we can assist with migration.
              </li>
            </ul>
          </div>

          <div data-id="element-493">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-494">
              7. AI Editing Requests
            </h2>
            <p data-id="element-495">
              Your package includes a monthly allocation of AI editing requests
              through the Magic Patterns platform. These requests allow you to
              make text, image, and layout changes to your website. Unused
              requests do not roll over to the following month. The AI editing
              feature is subject to the terms and capabilities of the Magic
              Patterns platform.
            </p>
          </div>

          <div data-id="element-496">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-497">8. Ownership</h2>
            <p data-id="element-498">
              Upon full payment, you own the website we build for you. You are
              free to modify, move, or manage it as you see fit. We retain the
              right to showcase the website in our portfolio unless you request
              otherwise in writing.
            </p>
          </div>

          <div data-id="element-499">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-500">
              9. Client Responsibilities
            </h2>
            <ul className="list-disc list-inside space-y-2 text-white/70 ml-4" data-id="element-501">
              <li data-id="element-502">
                Provide all necessary content (text, images, logos) in a timely
                manner.
              </li>
              <li data-id="element-503">
                Provide clear and constructive feedback during revision rounds.
              </li>
              <li data-id="element-504">
                Ensure that all content you provide is owned by you or properly
                licensed.
              </li>
              <li data-id="element-505">Maintain your own domain registration and renewals.</li>
            </ul>
          </div>

          <div data-id="element-506">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-507">
              10. Refund Policy
            </h2>
            <p data-id="element-508">
              If we have not yet started work on your website, you may request a
              full refund. Once work has begun, refunds are handled on a
              case-by-case basis depending on the amount of work completed. We
              aim to resolve any issues through additional revisions before
              considering refunds.
            </p>
          </div>

          <div data-id="element-509">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-510">
              11. Limitation of Liability
            </h2>
            <p data-id="element-511">
              We provide website design and development services to the best of
              our ability. We are not liable for any indirect, incidental, or
              consequential damages arising from the use of your website,
              including but not limited to loss of revenue, data, or business
              opportunities. Our total liability shall not exceed the amount
              paid for the service.
            </p>
          </div>

          <div data-id="element-512">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-513">
              12. Changes to These Terms
            </h2>
            <p data-id="element-514">
              We reserve the right to update these Terms at any time. Changes
              will be posted on this page with an updated date. Continued use of
              our services after changes constitutes acceptance of the new
              Terms.
            </p>
          </div>

          <div data-id="element-515">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-516">
              13. Contact Us
            </h2>
            <p data-id="element-517">
              If you have any questions about these Terms of Service, please
              contact us at:
              <br data-id="element-518" />
              <span className="text-[#c9a84c]" data-id="element-519">nmservicesww@gmail.com</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}